import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const PaymentCash = (props: IconProps): JSX.Element => (
  <SvgIcon size={props.size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 20H23V4H1V20Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 12C17 14.762 14.762 17 12 17C9.238 17 7 14.762 7 12C7 9.238 9.238 7 12 7C14.762 7 17 9.238 17 12ZM14.3291 12.96C14.3291 14.051 13.5301 15 11.7711 15C10.9191 15 10.0221 14.764 9.4251 14.341L9.9871 13.25C10.4531 13.603 11.0951 13.805 11.7371 13.805C12.4481 13.805 12.8881 13.506 12.8881 13.005C12.8881 12.522 12.5711 12.204 11.4561 12.204H9.8821L10.1981 8.741H13.9511V9.885H11.3851L11.2881 11.054H11.7891C13.6091 11.054 14.3291 11.871 14.3291 12.96Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default PaymentCash;
